(function() {
  define('tlhServicesPosition',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesPosition', []).factory('TlhPositionService', [
      function() {
        var factory, getNextActiveElement, getPreviousActiveElement, moveElement, update;
        factory = {};
        update = function(elements, startPosition, increase) {
          var element, _i, _len, _results;
          if (elements == null) {
            elements = [];
          }
          if (startPosition == null) {
            startPosition = 0;
          }
          _results = [];
          for (_i = 0, _len = elements.length; _i < _len; _i++) {
            element = elements[_i];
            if (element.position >= startPosition) {
              if (increase) {
                _results.push(element.position++);
              } else {
                _results.push(element.position--);
              }
            } else {
              _results.push(void 0);
            }
          }
          return _results;
        };
        factory.increase = function(elements, startPosition) {
          return update(elements, startPosition, true);
        };
        factory.decrease = function(elements, startPosition) {
          return update(elements, startPosition, false);
        };
        factory.max = function(elements) {
          var element, max, _i, _len;
          if (elements == null) {
            elements = [];
          }
          max = 0;
          for (_i = 0, _len = elements.length; _i < _len; _i++) {
            element = elements[_i];
            if (element.position > max) {
              max = element.position;
            }
          }
          return max;
        };
        factory.moveElementUp = function(element, elements) {
          return moveElement(element, elements, true);
        };
        factory.moveElementDown = function(element, elements) {
          return moveElement(element, elements, false);
        };
        moveElement = function(element, elements, up) {
          var originalPosition, otherElementToMove;
          originalPosition = element.position;
          otherElementToMove = up ? getPreviousActiveElement(originalPosition, elements) : getNextActiveElement(originalPosition, elements);
          if (otherElementToMove) {
            element.position = otherElementToMove.position;
            return otherElementToMove.position = originalPosition;
          }
        };
        getPreviousActiveElement = function(originalPosition, elements) {
          var element, previousElement, _i, _len;
          previousElement = null;
          for (_i = 0, _len = elements.length; _i < _len; _i++) {
            element = elements[_i];
            if (element.isActive && element.position < originalPosition && (!previousElement || element.position > previousElement.position)) {
              previousElement = element;
            }
          }
          return previousElement;
        };
        getNextActiveElement = function(originalPosition, elements) {
          var element, nextElement, _i, _len;
          nextElement = null;
          for (_i = 0, _len = elements.length; _i < _len; _i++) {
            element = elements[_i];
            if (element.isActive && element.position > originalPosition && (!nextElement || element.position < nextElement.position)) {
              nextElement = element;
            }
          }
          return nextElement;
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=position.js.map
;
